import api from "../../api/axios";

export async function getPlanejamentoMensalResumo({ month, gerencia } = {}) {
  const params = {};
  if (month) params.month = month;
  if (gerencia) params.gerencia = gerencia;
  const res = await api.get("/wf-1-mensal/resumo", { params });
  return res?.data || {};
}

export async function getPlanejamentoMensalPlano({ month, gerencia, coordenador } = {}) {
  const params = {};
  if (month) params.month = month;
  if (gerencia) params.gerencia = gerencia;
  if (coordenador) params.coordenador = coordenador;
  const res = await api.get("/wf-1-mensal/plano", { params });
  return res?.data || {};
}

export async function getAjusteMensalPlano({ month, gerencia, coordenador } = {}) {
  const params = {};
  if (month) params.month = month;
  if (gerencia) params.gerencia = gerencia;
  if (coordenador) params.coordenador = coordenador;
  const res = await api.get("/wf-1-mensal/ajuste", { params });
  return res?.data || {};
}

export async function atualizarAjusteMensalLinha({
  month,
  gerencia,
  coordenador,
  atividade,
  unidade,
  grupo,
  status_linha,
  semanas,
} = {}) {
  const res = await api.post("/wf-1-mensal/ajuste/linha", {
    month,
    gerencia,
    coordenador,
    atividade,
    unidade,
    grupo,
    status_linha,
    semanas,
  });
  return res?.data || {};
}

export async function aprovarAjusteMensalGeral({ month } = {}) {
  const res = await api.post("/wf-1-mensal/ajuste/aprovar-geral", { month });
  return res?.data || {};
}

export async function getContratoMensalPlano({ month, gerencia, coordenador } = {}) {
  const params = {};
  if (month) params.month = month;
  if (gerencia) params.gerencia = gerencia;
  if (coordenador) params.coordenador = coordenador;
  const res = await api.get("/wf-1-mensal/contrato", { params });
  return res?.data || {};
}

export async function atualizarContratoMensalLinha({
  month,
  gerencia,
  coordenador,
  atividade,
  unidade,
  grupo,
  contrato_status,
  semanas,
} = {}) {
  const res = await api.post("/wf-1-mensal/contrato/linha", {
    month,
    gerencia,
    coordenador,
    atividade,
    unidade,
    grupo,
    contrato_status,
    semanas,
  });
  return res?.data || {};
}

export async function salvarPlanejamentoMensalPlano({ month, gerencia, coordenador, entries } = {}) {
  const res = await api.post("/wf-1-mensal/plano", {
    month,
    gerencia,
    coordenador,
    entries,
  });
  return res?.data || {};
}

export async function aprovarPlanejamentoMensalCoordenador({ month, gerencia, coordenador } = {}) {
  const res = await api.post("/wf-1-mensal/plano/aprovar-coordenador", {
    month,
    gerencia,
    coordenador,
  });
  return res?.data || {};
}
